import React from "react";
import AbstractExtranetRegisterStepper from "../../../../stepper/AbstractExtranetRegisterStepper";
import PathManager from "../../../../../helpers/PathManager";
import FormStepperContainer from "../../../../stepper/FormStepperContainer";
import FormBlocContainer from "../../../../layout/form/FormBlocContainer";
import LastnameInput from "../../../../layout/form/inputs/text/LastnameInput";
import TextInput from "../../../../layout/form/inputs/text/TextInput";
import SSDateInput from "../../../../layout/form/inputs/date/SSDateInput";
import EmailInput from "../../../../layout/form/inputs/text/EmailInput";
import PasswordInput from "../../../../layout/form/inputs/text/PasswordInput";
import ReactPasswordChecklist from "react-password-checklist";
import Grid from "@mui/material/Grid";
import DOMHelper from "../../../../../helpers/DOMHelper";
import {ValidatorForm} from "react-material-ui-form-validator";
import {Link} from "react-router-dom";
import AbstractCheckboxValidator from "../../../../layout/form/inputs/checkbox/AbstractCheckboxValidator";
import {toggleLoading} from "../../../../../store/slices/loadingSlice";
import { withStyles } from '@mui/styles';
import withKeycloak from "../../../../../helpers/hooks/class/withKeycloak";
import {connect} from "react-redux";
import InsuredRegistrationService from "../../../../../api/extranet/services/InsuredRegistrationService";
import withReactContent from "sweetalert2-react-content";
import SweetAlert from "sweetalert2";
import {Typography} from "@mui/material";

const ReactSweetAlert = withReactContent(SweetAlert);

class SaisieStep extends AbstractExtranetRegisterStepper {

    state = {
        lastname: '',
        firstname: '',
        address: '',
        addressExtend: '',
        cp: '',
        city: '',
        birthdate: '',
        password: '',
        confirmPassword: '',
        email: '',
        confirmEmail: '',
        agreeConditions: false,

        insuredData: {},
        foundCities: [],

        ...this.props.data,
        ...this.state
    }

    constructor(props) {
        super(props);
        console.log("init")
        console.log(this.props)
        console.log(this.state)
        this.mainForm = React.createRef();
        this.pathManager = new PathManager(this.props.history)
    }


    componentDidMount() {
        super.componentDidMount();
        ValidatorForm.addValidationRule('isTruth', this.isTruth)
        if (this.state.hasOwnProperty('insuredData')) {
            let { insuredData, lastname, birthdate } = this.state;
            this.setState({
                lastname: lastname,
                firstname: insuredData.prenomAssure,
                address: insuredData.address,
                addressExtend: insuredData.addressExtend + ' ' + insuredData.department,
                cp: insuredData.cp,
                city: insuredData.city,
                foundCities: [insuredData.city],
                birthdate: insuredData.birthdate,
            })
        }

    }

    componentWillUnmount() {
        super.componentWillUnmount();
        ValidatorForm.removeValidationRule('isTruth')

    }

    isTruth = (value) => {
        return value;
    }

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value})
    }

    handleCheck = (event) => {
        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({
            [event.target.name] : value
        });
    }

    verifyEmail = async () => {
        this.props.toggleLoading();
        const isAbleToCreateAccount = await InsuredRegistrationService.verifyEmail(this.state.email);
        this.props.toggleLoading();
        return isAbleToCreateAccount;
    }

    handleVerificationNext = () => {
        this.mainForm.current.isFormValid(false)
            .then(async (value) => {
                if (value) {
                    // call
                    const verifyEmail = await this.verifyEmail();
                    if (!verifyEmail.isExists) {
                        this.props.handleNext(this.state);
                    } else {
                        this.showEmailExistsAlert();
                    }
                } else {
                    DOMHelper.scrollToError();
                }
            })
        ;
    }

    showEmailExistsAlert = () => {
        ReactSweetAlert.fire({
            title: `<i class="fas fa-exclamation-circle"></i> Courriel déjà existant`,
            html: `<p>Votre adresse e-mail existe déjà, souhaitez-vous réinitialiser votre mot de passe ?</p>`,
            reverseButtons: false,
            showCancelButton: true,
            cancelButtonText: 'Non',
            cancelButtonColor: '#EF595D',
            showConfirmButton: true,
            confirmButtonColor: '#36B8C9',
            confirmButtonText: 'Oui',
            allowOutsideClick: false
        }).then((confirm) => {
            if (confirm.value) {
                this.props.keycloak.login();
            } else {
                this.setState({
                    email: '',
                    confirmEmail: ''
                })
            }
        })
    }

    render = () => {
        return <FormStepperContainer
            ref={this.mainForm}
            label={"Formulaire de saisie"}
            activeStep={this.props.activeStep}
            nbStep={this.props.nbStep}
            id={this.state.id}
            handleBack={this.handleBackHistory}
            handleNext={this.handleVerificationNext}
            autoComplete="off"
        >
            <FormBlocContainer >
                <Grid container spacing={2} >
                <Grid item xs={0} sm={1}></Grid>
                <Grid item xs={11}>
                    <Typography variant="h3">
                        Civilité
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={1}>
                </Grid>
                <Grid item xs={12} sm={3}>
                <LastnameInput
                    label={"Nom d'usage"}
                    name={"lastname"}
                    value={this.state.lastname}
                    disabled
                />
                </Grid>
                <Grid item xs={12} sm={3}>
                <TextInput
                    label={"Prénom"}
                    name={"firstname"}
                    value={this.state.firstname}
                    disabled
                />
                </Grid>
                <Grid item xs={12} sm={3}>
                <SSDateInput
                    name={"birthdate"}
                    value={this.state.birthdate}
                    ss={this.state.ssNum}
                    readOnly
                    disabled
                />
                </Grid>
                 <Grid item xs={12} sm={1}></Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={0} sm={1}></Grid>
                    <Grid item xs={11} >
                        <Typography variant="h3" sx={{ paddingTop: 2 }}>
                            Courriel
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={1}>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <EmailInput
                            label={"E-mail*"}
                            name={"email"}
                            value={this.state.email}
                            handleChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <EmailInput
                            xs={12}
                            sm={6}
                            label={"Confirmation E-mail*"}
                            name={"confirmEmail"}
                            value={this.state.confirmEmail}
                            confirmEmail={this.state.email}
                            handleChange={this.handleChange}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={0} sm={1}></Grid>
                    <Grid item xs={11}>
                        <Typography variant="h3" sx={{ paddingTop: 2 }}>
                            Mot de passe
                        </Typography>
                    </Grid>
                    <Grid item xs={0} sm={1}>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <PasswordInput
                            name={"password"}
                            value={this.state.password}
                            handleChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <PasswordInput
                            label={"Confirmation de mot de passe*"}
                            name={"confirmPassword"}
                            value={this.state.confirmPassword}
                            confirmPassword={this.state.password}
                            handleChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item xs={0} sm={5}></Grid>
                    <Grid item xs={0} sm={1}></Grid>
                    {
                        this.state.password && <Grid xs={12} sm={10} item>
                            <ReactPasswordChecklist
                                rules={["lowercase","minLength","specialChar","number","capital","match"]}
                                minLength={12}
                                value={this.state.password}
                                valueAgain={this.state.confirmPassword}
                                onChange={(isValid) => {}}
                                messages={{
                                    minLength: "Le mot de passe doit contenir au moins 12 caractères.",
                                    capital: "Le mot de passe doit contenir au moins une lettre majuscule.",
                                    lowercase: "Le mot de passe doit contenir au moins une lettre minuscule.",
                                    number: "Le mot de passe doit contenir au moins un chiffre.",
                                    specialChar: "Le mot de passe doit contenir au moins un caractère spécial.",
                                    match: "La confirmation du mot de passe ne correspond pas au mot de passe saisi.",
                                }}
                            />
                        </Grid>
                    }
                </Grid>
                <Grid item xs={0} sm={1}>
                </Grid>
                <Grid item xs={6} sm={5}>
                       <p className="legende">*Champs obligatoires</p>
                </Grid>
                <Grid item xs={6} sm={5}>
                </Grid>
                <Grid container spacing={2}>
                <Grid item xs={0} sm={1}></Grid>
                    <Grid item xs={12} sm={11}>
                        <Typography variant="h3">
                            Conditions générales
                        </Typography>
                    </Grid>
                    <Grid item xs={0} sm={1}></Grid>
                    <Grid item xs={12} sm={11}>
                        <AbstractCheckboxValidator
                            label={(<React.Fragment>
                                J'ai lu et j'accepte les <Link to={`/ui/informations-legales`} target={"_blank"}>conditions générales d'utilisation</Link>.
                            </React.Fragment>)}
                            // label={"toto"}
                            name={"agreeConditions"}
                            validators={['isTruth']}
                            errorMessages={['Vous devez accepter les conditions générales']}
                            checked={this.state.agreeConditions}
                            value={this.state.agreeConditions}
                            handleChange={this.handleCheck}
                        />
                    </Grid>
                <Grid item xs={12} sm={1}>
                </Grid>
                </Grid >
            </FormBlocContainer >
        </FormStepperContainer>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toggleLoading: () => dispatch(toggleLoading())
    }
}

export default withStyles(null, {withTheme: true})(withKeycloak(connect(null, mapDispatchToProps)(SaisieStep)));
